import { useSaveStandingOrderChangesMutation } from '@/generated/graphql'
import { useCallback } from 'react'
import { useNotifications } from '@/store/notificationStore'
import { useRouter } from 'next/navigation'
import { useTranslation } from 'react-i18next'

export const useSaveStandingOrderMutation = (
  basketId?: string | null,
  editSessionId?: string | null,
  standingOrderId?: string | null,
) => {
  const router = useRouter()
  const { t } = useTranslation()
  const { showError, showSuccess } = useNotifications()
  const [run, result] = useSaveStandingOrderChangesMutation({
    fetchPolicy: 'no-cache',
  })

  const error =
    result.error ||
    (result.called && !result.loading && !result.data?.basket ? 'Unknown error' : null)

  const saveStandingOrder = useCallback(async () => {
    if (!basketId || !editSessionId) {
      showError(t('marketplace:failedToSave'))
      return
    }
    try {
      await run({
        variables: {
          basketId,
          editSessionId,
        },
      })
      showSuccess(t('marketplace:standingOrderSavedRedirecting'))
      router.push(`/dashboard/standing-orders/${standingOrderId}`)
    } catch {
      showError(t('marketplace:failedToSave'))
    }
  }, [basketId, editSessionId, run, showError, showSuccess, t, router, standingOrderId])

  return {
    run: saveStandingOrder,
    loading: result.loading,
    updated: result.called,
    error,
  }
}
